module.exports = __webpack_public_path__ + "static/media/truck-blue.7822c888.svg";